import { Component } from "@angular/core";
import { FormGroup, FormControl } from '@angular/forms';
import { Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "./auth.service";
import { AuthCredentials } from "app/shared/data/auth-credentials";


@Component({
    selector: 'login',
    templateUrl: 'login.component.html'})
  export class LoginComponent {

    model = new AuthCredentials("", "");
    error:String = null;

    constructor(
                private authService: AuthService, 
                private router: Router) {
        authService.tryAutologin();
    }

    login() {
        if (this.model.username && this.model.password) {
            let promise = this.authService.login(<string>this.model.username, <string>this.model.password);
            promise.then(
                res=> this.handleLoginResult(res),
                msg=> console.log(msg)
            );            
        }
    }

    private handleLoginResult(res: String) {
        if (res==null) {
            console.log("User is logged in");
            this.router.navigateByUrl('/');
        } else {
            this.error = res;
            console.log(res);
        }
    }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/security/login.component.ts